
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommunicationTemplateApi } from '../api/communicationtemplate.api';
import { switchMap, map } from 'rxjs/operators';

import { CommunicationTemplateData, CommunicationTemplate } from '../../../interfaces/masters/communicationtemplate' ;
@Injectable()
export class CommunicationTemplateService extends CommunicationTemplateData {

    constructor(private api: CommunicationTemplateApi) {
      super();
    }
  
  
    list(url: string): Observable<CommunicationTemplate[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CommunicationTemplate>{
        return this.api.getById(url);
    }
  
    create(url: string, data:CommunicationTemplate): Observable<CommunicationTemplate[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:CommunicationTemplate): Observable<CommunicationTemplate> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  